import {
  Button,
  ExternalLinkIcon,
  Notice,
  Separator,
} from '@buffer-mono/popcorn'

import { getSettingsUrl } from '../../shared/utils/getSettingsUrl'
import { SettingsRow } from '../../shared/components/SettingsRow'
import { useGetPortalSession } from '../hooks/useGetPortalSession'

import type { JSX } from 'react'

export const LegacyPlanBilling = ({
  canOpenBillingPortal,
}: {
  canOpenBillingPortal: boolean
}): JSX.Element => {
  const { getCustomerPortalSession, loading: portalSessionLoading } =
    useGetPortalSession()

  return (
    <>
      <Notice>
        <Notice.Text>
          You&rsquo;re on a legacy Buffer plan. Our Customer Advocacy team can
          walk you through moving to a current plan, or answer any questions
          about your subscription.
        </Notice.Text>
        <Notice.Actions>
          <Button
            variant="secondary"
            onClick={(): void => {
              window.Brainfish?.Widgets?.open()
            }}
          >
            Contact Customer Advocacy
          </Button>
        </Notice.Actions>
      </Notice>

      {canOpenBillingPortal && (
        <>
          <Separator />
          <SettingsRow id="legacy-billing-portal">
            <SettingsRow.Header>
              <SettingsRow.Title>
                Payment &amp; Billing Details
              </SettingsRow.Title>
              <SettingsRow.Description>
                Update your payment method, billing address, and tax details.
              </SettingsRow.Description>
            </SettingsRow.Header>
            <SettingsRow.Control>
              <Button
                variant="secondary"
                onClick={(): void => {
                  getCustomerPortalSession({
                    returnURL: getSettingsUrl(),
                    cta: 'billing-legacyPlan-manageBilling-1',
                  })
                }}
                disabled={portalSessionLoading}
              >
                Manage Billing
                <ExternalLinkIcon />
              </Button>
            </SettingsRow.Control>
          </SettingsRow>
        </>
      )}
    </>
  )
}
